import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { routeSchemaObject } from "../routeSchema";
import { validateProperty, validate } from "../../Common";
import { PageHeader } from "../../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import Joi from "@hapi/joi";
import groupService from "../../Group/services";
import collectionCategoryService from "../../CollectionCategory/services";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";

const screenCode = "ROUTE";

export function RouteAddEdit(props) {
  const { data, edit } = props.location;
  const [title, setTitle] = useState("Add Route");
  const [buttonName, setButtonName] = useState("Save");
  const [isChanged, setIsChanged] = useState(0);
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [collectionCategories, setCollectionCategories] = useState([]);
  const [route, setRoute] = useState({
    groupID: '0',
    operationEntityID: "0",
    collectionCategoryID: "0",
    collectionPointCode: "",
    collectionPointName: "",
    collectionPointLocation: "",
    isActive: true,
    factoryWeighValidationEnabled: false,
  });
  const [errors, setErrors] = useState({});
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success",
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const schema = Joi.object(routeSchemaObject).options({ allowUnknown: true });

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    setIsChanged(isChanged + 1);
  }, [route]);

  useEffect(() => {
    trackPromise(getEsatesForDropDown());
  }, [route.groupID]);

  useEffect(() => {
    trackPromise(getCollectionCategoryForDropDown());
  }, [route.operationEntityID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "ADDEDITROUTE"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    if (data && edit) {
      setTitle("Edit Route");
      setRoute(data);
      setButtonName("Update");
    } else {
      setTitle("Add Route");
      var token = tokenService.getUserDetailsFromToken();
      setRoute({
        ...route,
        groupID: token.groupID,
        operationEntityID: token.operationEntityID,
      });
    }

    trackPromise(getGroupsForDropDown());
  }

  async function getEsatesForDropDown() {
    const factoryList = await services.getFactoryByGroupID(route.groupID);
    setFactories(factoryList);
  }

  async function getGroupsForDropDown() {
    const groupsList = await groupService.getGroupsForDropdown();
    setGroups(groupsList);
  }

  async function getCollectionCategoryForDropDown() {
    const collectionCategories =
      await collectionCategoryService.GetCollectionCategoryByOperationEntityID(
        route.operationEntityID
      );
    setCollectionCategories(collectionCategories);
  }

  function handleChange(e) {
    const target = e.target;

    if (target.name === "collectionPointCode") {
      if (target.value.length === 3) return false;
    }

    const value =
      target.name === "isActive" ||
      target.name === "factoryWeighValidationEnabled"
        ? target.checked
        : target.value;

    const error = { ...errors };
    const errorMessage = validateProperty(target, routeSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setRoute({
      ...route,
      [e.target.name]: value,
    });
    setErrors(error);
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setRoute({
      ...route,
      groupID: target.value,
      operationEntityID: "0",
      collectionCategoryID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setRoute({
      ...route,
      operationEntityID: target.value,
      collectionCategoryID: "0",
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, routeSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function handleSave(e) {
    e.preventDefault();

    const errorMessages = validate(schema, route);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    if (!edit) {
      const response = await services.saveRoute(route);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      afterSuccessfulyChanged(response.statusCode);
    } else if (edit) {
      const response = await services.editData(route);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      afterSuccessfulyChanged(response.statusCode);
    }
  }

  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      clearState();
      setTimeout(() => {
        props.history.push({ pathname: "/routes" });
      }, 1500);
    }
  }

  function clearState() {
    var token = tokenService.getUserDetailsFromToken();
    setRoute({
      ...route,
      groupID: permissionList.isGroupFilterEnabled ? "0" : token.groupID,
      operationEntityID: permissionList.isOperationEntityFilterEnabled
        ? "0"
        : token.operationEntityID,
      collectionCategoryID: "0",
      collectionPointCode: "",
      collectionPointName: "",
      collectionPointLocation: "",
      isActive: true,
    });
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <option key={key} value={key}>
            {value}
          </option>
        );
      }
    }
    return items;
  }

  function onCancelClick() {
    clearState();
    setErrors({});
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title={title}
              isButtonEnable={true}
              buttonText="Back to Listing"
              path="/routes"
              isChanged={isChanged}
            />
            <form onSubmit={(e) => handleSave(e)}>
              <div className="card-body">
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <TextField
                      fullWidth
                      select
                      label="Group *"
                      name="groupID"
                      id="groupID"
                      //name="groupID"
                      disabled={!permissionList.isGroupFilterEnabled}
                      value={route.groupID}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <option value="0">--Select Group--</option>
                      {generateDropDownMenu(groups)}
                    </TextField>
                    {errors["groupID"] && (
                      <span id="errbranchCode" className="text text-danger">
                        {errors["groupID"]}
                      </span>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <TextField
                      fullWidth
                      select
                      label="Factory *"
                      id="operationEntityID"
                      name="operationEntityID"
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      value={route.operationEntityID}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <option value="0">--Select Factory--</option>
                      {generateDropDownMenu(factories)}
                    </TextField>
                    {errors["operationEntityID"] && (
                      <span id="errbranchCode" className="text text-danger">
                        {errors["operationEntityID"]}
                      </span>
                    )}
                  </div>
                  <div className="col-md-4 pb-1">
                    <TextField
                      fullWidth
                      select
                      label="Collection Catagory *"
                      id="collectionCategoryID"
                      name="collectionCategoryID"
                      value={route.collectionCategoryID}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="0">--Select Collection Category--</option>
                      {generateDropDownMenu(collectionCategories)}
                    </TextField>
                    {errors["collectionCategoryID"] && (
                      <span id="errbranchCode" className="text text-danger">
                        {errors["collectionCategoryID"]}
                      </span>
                    )}
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md pb-1">
                    <TextField
                      fullWidth
                      label="Route Code *"
                      name="collectionPointCode"
                      id="collectionPointCode"
                      value={route.collectionPointCode}
                      type="number"
                      onChange={(e) => handleChange(e)}
                    />
                    {errors["collectionPointCode"] && (
                      <span id="errbranchCode" className="text text-danger">
                        {errors["collectionPointCode"]}
                      </span>
                    )}
                  </div>
                  <div className="col-md-4 pb-1">
                    <label htmlFor="routeName"></label>
                    <TextField
                      fullWidth
                      label="Route Name *"
                      name="collectionPointName"
                      id="collectionPointName"
                      value={route.collectionPointName}
                      type="text"
                      onChange={(e) => handleChange(e)}
                    />
                    {errors["collectionPointName"] && (
                      <span id="errbranchCode" className="text text-danger">
                        {errors["collectionPointName"]}
                      </span>
                    )}
                  </div>
                  <div className="col-md-4 pb-1">
                    <TextField
                      fullWidth
                      label="Route Location"
                      name="collectionPointLocation"
                      id="collectionPointLocation"
                      value={route.collectionPointLocation}
                      type="text"
                      onChange={(e) => handleChange(e)}
                    />
                    {errors["collectionPointLocation"] && (
                      <span id="errbranchCode" className="text text-danger">
                        {errors["collectionPointLocation"]}
                      </span>
                    )}
                  </div>
                </div>

                <label>Active</label>
                <div className="form-group row">
                  <div className="col-md ">
                    <input
                      id="isActive"
                      switch="none"
                      className="mr-2"
                      type="checkbox"
                      name="isActive"
                      onChange={(e) => handleChange(e)}
                      checked={route.isActive}
                    />
                    <label
                      htmlFor="isActive"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                  </div>
                </div>
                <label>Factory Weigh Validation</label>
                <div className="form-group row">
                  <div className="col-md ">
                    <input
                      id="factoryWeighValidationEnabled"
                      switch="none"
                      className="mr-2"
                      type="checkbox"
                      name="factoryWeighValidationEnabled"
                      onChange={(e) => handleChange(e)}
                      checked={route.factoryWeighValidationEnabled}
                    />
                    <label
                      htmlFor="factoryWeighValidationEnabled"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                  </div>
                </div>
              </div>

              <div className="card-footer">
                <input
                  disabled={validate(schema, route)}
                  type="submit"
                  className="btn btn-primary"
                  value={buttonName}
                />
                <input
                  type="reset"
                  className="btn btn-warning pull-right"
                  value="Clear"
                  onClick={onCancelClick}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
